var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuranCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Germany"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-.7 0-1.41-.07-2.1-.22-4.59-.98-113.15-24.89-173.5-91.88-1.87-2.08-2.79-4.85-2.53-7.64.12-1.23 11.55-125.2-.01-274.64-.22-2.78.74-5.52 2.63-7.56s4.55-3.21 7.34-3.21h336.33c2.79 0 5.45 1.16 7.34 3.21s2.85 4.79 2.63 7.56c-11.57 149.45-.13 273.41-.01 274.64.26 2.79-.65 5.56-2.53 7.64-60.34 66.99-168.9 90.9-173.5 91.88-.69.15-1.39.22-2.1.22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Flag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 502s109.29-23.44 168.16-88.8c0 0-11.77-124.22 0-276.36h-336.32c11.77 152.14 0 276.36 0 276.36 58.87 65.35 168.16 88.8 168.16 88.8z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.16 136.84c-3.37 43.63-4.81 84.96-5.15 121.72h-326.02c-.34-36.77-1.78-78.1-5.15-121.72h336.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.18 380.28c1.57-27.32 3.28-69.99 2.81-121.71h326.03c-.47 51.72 1.24 94.39 2.82 121.71z",
    fill: "#d00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m442.17 128.12c-.38 0-.76-.01-1.14-.04-70.14-4.34-153.62-54.31-185.02-74.72-31.4 20.41-114.88 70.38-185.02 74.72-.38.02-.77.04-1.14.04-4.93 0-9.57-1.93-13.06-5.44-3.48-3.5-5.39-8.14-5.39-13.07 0-9.75 7.64-17.86 17.4-18.47 73.64-4.6 180.46-77.88 181.53-78.62 1.71-1.18 3.7-1.77 5.69-1.77s3.98.59 5.69 1.77c1.07.74 107.86 74.02 181.52 78.61 9.75.61 17.39 8.72 17.39 18.47s-8.27 18.52-18.44 18.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.64 118.1c-73.22-4.53-163.6-62-185.64-76.71-22.04 14.71-112.42 72.18-185.64 76.71-4.87.3-8.97-3.62-8.97-8.5 0-4.51 3.52-8.21 8.02-8.49 77.36-4.83 186.61-80.37 186.61-80.37s109.22 75.54 186.58 80.37c4.5.28 8.02 3.98 8.02 8.49 0 4.88-4.1 8.8-8.97 8.5z",
    fill: "#e5bf89"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m23.28 136.84c-12.83 0-23.28-10.44-23.28-23.28s10.44-23.28 23.28-23.28h465.45c12.83 0 23.28 10.44 23.28 23.28s-10.44 23.28-23.28 23.28z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffe0a9",
    height: 26.56,
    rx: 13.28,
    width: 492,
    x: 10,
    y: 100.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 65.48c-18.05 0-32.74-14.69-32.74-32.74s14.69-32.74 32.74-32.74 32.74 14.69 32.74 32.74-14.69 32.74-32.74 32.74z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 32.74,
    fill: "#ffe0a9",
    r: 22.74
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuranCardIcon);
export default __webpack_public_path__ + "static/media/quranCardIcon.72f1d2b65ec430cf2df298ba8d3e9e39.svg";
export { ForwardRef as ReactComponent };